// SolidColorButton.jsx
import React, { useState, useEffect } from "react";
import "./solidColorBtn.scss";

const SolidColorButton = ({
  className = "",
  onClick,
  disabled = false,
  isSubmit = false,
  solidColorBtnImage = null,
  solidColorBtnText = "",
  solidColorBtnTextFontSize,
  solidColorBtnWidth,
  solidColorBtnHeight,
  solidColorBtnFontFamily,
  solidColorBtnFontWeight,
  solidColorBtnFontColor,
  solidColorBtnBorderRadius,
  solidColorBtnBoxShadow,
  solidColorBtnBorderColor,
  marginLeft = "0px",
  marginRight = "0px",
  extraStyles = {},
}) => {
  return (
    <button
      className={`solid-color-btn position-relative ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={isSubmit ? "submit" : "button"}
      style={{
        ...extraStyles,
        width: solidColorBtnWidth,
        height: solidColorBtnHeight,
        borderRadius: solidColorBtnBorderRadius,
        borderColor: solidColorBtnBorderColor,
        marginLeft,
        marginRight,
        boxShadow: solidColorBtnBoxShadow,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {solidColorBtnImage}
        <span
          style={{
            marginLeft: solidColorBtnImage ? "5px" : "0",
            fontSize: solidColorBtnTextFontSize,
            fontFamily: solidColorBtnFontFamily,
            fontWeight: solidColorBtnFontWeight,
            color: solidColorBtnFontColor,
          }}
        >
          {solidColorBtnText}
        </span>
      </div>
    </button>
  );
};

export default SolidColorButton;
